import React, { useState } from "react";

const FullScreenLabDetailsModal = ({ open, onClose, data }) => {
  const { panels = [] } = data;
  const [selectedPanelIndex, setSelectedPanelIndex] = useState(0);
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);

  if (!open || !data) return null;

  const selectedPanel = panels[selectedPanelIndex];

  const getStatusDot = (value, refRange) => {
    if (!refRange) return null;
    const [min, max] = refRange.split("-").map(parseFloat);
    const isNormal = value >= min && value <= max;
    return (
      <span
        className={`inline-block w-3 h-3 rounded-full mr-2 ${
          isNormal ? "bg-green-500" : "bg-red-500"
        }`}
      />
    );
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white w-full h-full sm:max-w-6xl sm:h-[90%] overflow-hidden relative rounded-md shadow-lg flex">
        {/* Left Sidebar for Panels */}
        <div className="w-64 bg-white border-r overflow-y-auto custom-scrollbar p-4">
          <div className="text-center font-semibold text-gray-700 mb-4">Panel</div>
          {panels.map((panel, index) => (
            <button
              key={index}
              onClick={() => {
                setSelectedPanelIndex(index);
                setSelectedDateIndex(0); // Reset date selection when panel changes
              }}
              className={`w-full mb-3 px-4 py-2 text-sm rounded-md border text-center break-words font-medium transition ${
                index === selectedPanelIndex
                  ? "bg-[#50869A] border-[#004d40] border shadow-[0px_1px_2px_#0000002e,0px_1px_3px_#0000001a] text-white"
                  : "bg-white text-gray-800 border border-gray-300 hover:bg-gray-50"
              }`}
            >
              {panel.panel_name}
            </button>
          ))}
        </div>

        {/* Right Section */}
        <div className="flex-1 overflow-y-auto relative">
          {/* Close Button */}
       

          {/* Header */}
          <div className="sticky top-0 z-10 bg-white border-b px-4 py-3 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <h2 className="text-lg font-semibold text-blue-700">
              {selectedPanel.panel_name}
            </h2>
            {/* Date Dropdown */}
            <div>

  {selectedPanel.tests[0]?.results?.length > 0 && (
              <select
                value={selectedDateIndex}
                onChange={(e) => setSelectedDateIndex(Number(e.target.value))}
                className="border border-gray-300 rounded px-3 py-1 text-sm mr-8 focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                {selectedPanel.tests[0].results.map((res, idx) => (
                  <option key={idx} value={idx}>
                    {res.date}
                  </option>
                ))}
              </select>
            )}

                 <button
            onClick={onClose}
            className=" text-gray-500 hover:text-black text-2xl font-bold z-20"
          >
            &times;
          </button>
            </div>
          
          </div>

          {/* Table Content */}
          <div className="p-4 overflow-x-auto">
            <table className="min-w-full text-sm text-start">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-left px-3 py-2 font-medium">Lab Test</th>
                  <th className="text-left px-3 py-2 font-medium">Date</th>
                  <th className="text-left px-3 py-2 font-medium">Value</th>
                  <th className="text-left px-3 py-2 font-medium">Ref. range</th>
                </tr>
              </thead>
              <tbody>
                {selectedPanel.tests.map((test, tIndex) => {
                  const result = test.results[selectedDateIndex];
                  return (
                    <tr key={tIndex} className="even:bg-gray-50">
                      <td className="px-3 py-2">{test.testname}</td>
                      <td className="px-3 py-2">{result?.date || "-"}</td>
                      <td className="px-3 py-2 flex items-center">
                        {getStatusDot(parseFloat(result?.value), result?.refrange)}
                        {result?.value || "-"}
                      </td>
                      <td className="px-3 py-2">{result?.refrange || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullScreenLabDetailsModal;
